/**
 * 云教材使用统计api v2（学期化）
 * 云教材使用统计 v2：学期化入参 + 周/月双周期输出。 与 v1（api.textbook_cx_jw_stat）的核心口径差异： 1. semesters 多选必填（至少一个），替代日期区间参数——学期过滤采用\"领取者集合\"口径（多选取并集）：    发放数 = 所选学期归属的兑换码数（fm_redeem_code.semester IN 所选学期，已按发放日期计算）；    使用数据 = 领取了所选学期教材的学生对该教材的全部学习数据（不限学习发生时间，累计口径）。 2. 周期输出的 label：月 = YYYY-MM；周 = 该周周一日期（YYYY-MM-DD，ISO 周一为首日）。    periodType 仅 period_usage_stat 接口使用，MONTH 为默认。 3. viewTime 保留 v1 的\"一键多码乘码数\"加权语义（SUM(时长×该学生该书码数)）。 4. \"使用\"的判定统一为：存在学习行为上报记录（fm_user_drill_history 有行）即算，    不要求时长大于 0——usageQuantity（按学生去重）与 usedWeekCount（按自然周去重）同口径。 
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import StatisticsItemVo from './StatisticsItemVo';




  /**
   * The TextbookStatV2Vo model module.
   * @module statistics/model/TextbookStatV2Vo
   * @version 2.0.0
   */

  /**
   * Constructs a new <code>TextbookStatV2Vo</code>.
   * @alias module:statistics/model/TextbookStatV2Vo
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>TextbookStatV2Vo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:statistics/model/TextbookStatV2Vo} obj Optional instance to populate.
   * @return {module:statistics/model/TextbookStatV2Vo} The populated <code>TextbookStatV2Vo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'redeemCount')) {
        obj['redeemCount'] = ApiClient.convertToType(data['redeemCount'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'costTime')) {
        obj['costTime'] = StatisticsItemVo.constructFromObject(data['costTime']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'usedWeekCount')) {
        obj['usedWeekCount'] = StatisticsItemVo.constructFromObject(data['usedWeekCount']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'exerciseCount')) {
        obj['exerciseCount'] = StatisticsItemVo.constructFromObject(data['exerciseCount']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'exerciseScore')) {
        obj['exerciseScore'] = StatisticsItemVo.constructFromObject(data['exerciseScore']);
      }
    }
    return obj;
  }

  /**
   * id（分组维度主键：院校/分院/专业/教材）
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 分组名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 兑换册数（该学期归属的兑换码数量）
   * @member {Integer} redeemCount
   */
  exports.prototype['redeemCount'] = undefined;
  /**
   * 每册平均使用时长(含练习)
   * @member {module:statistics/model/StatisticsItemVo} costTime
   */
  exports.prototype['costTime'] = undefined;
  /**
   * 每册平均使用周数（该册教材存在学习行为上报记录的去重自然周数合计 ÷ 发放册数；只要求存在上报记录，不要求时长大于 0；无任何上报时为 0）
   * @member {module:statistics/model/StatisticsItemVo} usedWeekCount
   */
  exports.prototype['usedWeekCount'] = undefined;
  /**
   * 每册平均练习题次
   * @member {module:statistics/model/StatisticsItemVo} exerciseCount
   */
  exports.prototype['exerciseCount'] = undefined;
  /**
   * 每册平均练习正确率
   * @member {module:statistics/model/StatisticsItemVo} exerciseScore
   */
  exports.prototype['exerciseScore'] = undefined;



  export default exports;
;


